import type * as Types from '../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type CreateJoyFeatureCheckoutMutationVariables = Types.Exact<{
  data: Types.CreateJoyFeatureCheckoutInput;
}>;

export type CreateJoyFeatureCheckoutMutation = {
  __typename?: 'Mutation';
  createJoyFeatureCheckout: { __typename?: 'StartStationeryCheckoutResponse'; checkoutUrl?: string | null };
};

export type GetJoyFeatureUserOrdersQueryVariables = Types.Exact<{
  ownerId: Types.Scalars['ID'];
  eventId?: Types.InputMaybe<Types.Scalars['ID']>;
}>;

export type GetJoyFeatureUserOrdersQuery = {
  __typename?: 'Query';
  stationeryPrintOrders: {
    __typename?: 'StationeryPrintOrdersView';
    count?: number | null;
    orders: Array<{
      __typename?: 'StationeryPrintOrder';
      id: string;
      orderNumber: string;
      currentStatus: Types.StationeryPrintOrderStatusEnum;
      ownerId: string;
      vendor: Types.StationeryPrintOrderVendorEnum;
      shippingAddress: {
        __typename?: 'StationeryPrintOrderShippingAddress';
        name: string;
        address1: string;
        address2?: string | null;
        city: string;
        region: string;
        postalCode: string;
        country: string;
        countryCode: string;
      };
    }>;
  };
};

export type GetOrdersByEventQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
}>;

export type GetOrdersByEventQuery = {
  __typename?: 'Query';
  stationeryPrintOrdersByEvent: {
    __typename?: 'StationeryPrintOrdersView';
    count?: number | null;
    orders: Array<{ __typename?: 'StationeryPrintOrder'; id: string; currentStatus: Types.StationeryPrintOrderStatusEnum; vendor: Types.StationeryPrintOrderVendorEnum }>;
  };
};

export type JoyFeatureCheckoutStationeryProductsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type JoyFeatureCheckoutStationeryProductsQuery = {
  __typename?: 'Query';
  stationeryProducts: Array<{
    __typename?: 'StationeryProduct';
    id: string;
    priceConfigId: string;
    priceCurrency: string;
    pricing:
      | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
      | { __typename?: 'StationeryTieredFlatFeePricing'; priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }> }
      | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
  }>;
};

export const CreateJoyFeatureCheckoutDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateJoyFeatureCheckout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateJoyFeatureCheckoutInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createJoyFeatureCheckout' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'checkoutUrl' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateJoyFeatureCheckoutMutationFn = Apollo.MutationFunction<CreateJoyFeatureCheckoutMutation, CreateJoyFeatureCheckoutMutationVariables>;

/**
 * __useCreateJoyFeatureCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateJoyFeatureCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJoyFeatureCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJoyFeatureCheckoutMutation, { data, loading, error }] = useCreateJoyFeatureCheckoutMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateJoyFeatureCheckoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateJoyFeatureCheckoutMutation, CreateJoyFeatureCheckoutMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateJoyFeatureCheckoutMutation, CreateJoyFeatureCheckoutMutationVariables>(CreateJoyFeatureCheckoutDocument, baseOptions);
}
export type CreateJoyFeatureCheckoutMutationHookResult = ReturnType<typeof useCreateJoyFeatureCheckoutMutation>;
export type CreateJoyFeatureCheckoutMutationResult = Apollo.MutationResult<CreateJoyFeatureCheckoutMutation>;
export type CreateJoyFeatureCheckoutMutationOptions = Apollo.BaseMutationOptions<CreateJoyFeatureCheckoutMutation, CreateJoyFeatureCheckoutMutationVariables>;
export const GetJoyFeatureUserOrdersDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetJoyFeatureUserOrders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ownerId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryPrintOrders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'ownerId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'ownerId' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shippingAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetJoyFeatureUserOrdersQuery__
 *
 * To run a query within a React component, call `useGetJoyFeatureUserOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJoyFeatureUserOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJoyFeatureUserOrdersQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetJoyFeatureUserOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetJoyFeatureUserOrdersQuery, GetJoyFeatureUserOrdersQueryVariables>) {
  return ApolloReactHooks.useQuery<GetJoyFeatureUserOrdersQuery, GetJoyFeatureUserOrdersQueryVariables>(GetJoyFeatureUserOrdersDocument, baseOptions);
}
export function useGetJoyFeatureUserOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetJoyFeatureUserOrdersQuery, GetJoyFeatureUserOrdersQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetJoyFeatureUserOrdersQuery, GetJoyFeatureUserOrdersQueryVariables>(GetJoyFeatureUserOrdersDocument, baseOptions);
}
export type GetJoyFeatureUserOrdersQueryHookResult = ReturnType<typeof useGetJoyFeatureUserOrdersQuery>;
export type GetJoyFeatureUserOrdersLazyQueryHookResult = ReturnType<typeof useGetJoyFeatureUserOrdersLazyQuery>;
export type GetJoyFeatureUserOrdersQueryResult = Apollo.QueryResult<GetJoyFeatureUserOrdersQuery, GetJoyFeatureUserOrdersQueryVariables>;
export const GetOrdersByEventDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrdersByEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryPrintOrdersByEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [{ kind: 'ObjectField', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetOrdersByEventQuery__
 *
 * To run a query within a React component, call `useGetOrdersByEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersByEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersByEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetOrdersByEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrdersByEventQuery, GetOrdersByEventQueryVariables>) {
  return ApolloReactHooks.useQuery<GetOrdersByEventQuery, GetOrdersByEventQueryVariables>(GetOrdersByEventDocument, baseOptions);
}
export function useGetOrdersByEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrdersByEventQuery, GetOrdersByEventQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetOrdersByEventQuery, GetOrdersByEventQueryVariables>(GetOrdersByEventDocument, baseOptions);
}
export type GetOrdersByEventQueryHookResult = ReturnType<typeof useGetOrdersByEventQuery>;
export type GetOrdersByEventLazyQueryHookResult = ReturnType<typeof useGetOrdersByEventLazyQuery>;
export type GetOrdersByEventQueryResult = Apollo.QueryResult<GetOrdersByEventQuery, GetOrdersByEventQueryVariables>;
export const JoyFeatureCheckoutStationeryProductsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JoyFeatureCheckoutStationeryProducts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryProducts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceConfigId' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductPricings' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductPricings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceCurrency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useJoyFeatureCheckoutStationeryProductsQuery__
 *
 * To run a query within a React component, call `useJoyFeatureCheckoutStationeryProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJoyFeatureCheckoutStationeryProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJoyFeatureCheckoutStationeryProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJoyFeatureCheckoutStationeryProductsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<JoyFeatureCheckoutStationeryProductsQuery, JoyFeatureCheckoutStationeryProductsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<JoyFeatureCheckoutStationeryProductsQuery, JoyFeatureCheckoutStationeryProductsQueryVariables>(
    JoyFeatureCheckoutStationeryProductsDocument,
    baseOptions,
  );
}
export function useJoyFeatureCheckoutStationeryProductsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JoyFeatureCheckoutStationeryProductsQuery, JoyFeatureCheckoutStationeryProductsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<JoyFeatureCheckoutStationeryProductsQuery, JoyFeatureCheckoutStationeryProductsQueryVariables>(
    JoyFeatureCheckoutStationeryProductsDocument,
    baseOptions,
  );
}
export type JoyFeatureCheckoutStationeryProductsQueryHookResult = ReturnType<typeof useJoyFeatureCheckoutStationeryProductsQuery>;
export type JoyFeatureCheckoutStationeryProductsLazyQueryHookResult = ReturnType<typeof useJoyFeatureCheckoutStationeryProductsLazyQuery>;
export type JoyFeatureCheckoutStationeryProductsQueryResult = Apollo.QueryResult<JoyFeatureCheckoutStationeryProductsQuery, JoyFeatureCheckoutStationeryProductsQueryVariables>;
